import React, { useState } from 'react';
import FormFields from '@pages/Forms/FormFields';
import './UserPage2.css';
import CommonFormFields from '../../../Forms/CommonFormFields';
interface formDataType {
  [key: string]: any;
}

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState2:any;
  handleFormChange2:(value: any, key: string, id: any, option: any, code: any, compositeRoleId?:any)=>void;
  onInputChange?:(value:string, key:string) => any;
  forceDistrictEnabled?: boolean;
};

const UserPage2 = ({ formData,formState2,handleFormChange2, onInputChange, forceDistrictEnabled = false }: propsType) => {
  // const [formState, setFormState] = useState({
  //   assign_role: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   state: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   district: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   block: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   ulb: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   village: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   ward: {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: '',
  //   },
  //   'Report with line listing data': {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: false,
  //   },
  //   'Offline mode access': {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: false,
  //   },
  //   'Multi-factor Authentication': {
  //     isError: false,
  //     message: '',
  //     isDisable: false,
  //     value: true,
  //   },
  // });

  // const handleFormChange = (value: string | boolean, key: string) => {
  //   setFormState((prevState: any) => ({
  //     ...prevState,
  //     [key]: {
  //       ...prevState[key],
  //       value: value,
  //     },
  //   }));
  // };
  return (
    <div className="user_details_form_page2">
      <form className="form_container_user_details2 create_user_user_details_wrapper">
        <CommonFormFields
          formData={formData}
          formState={formState2}
          handleFormChange={handleFormChange2}
          onInputChange={onInputChange}
          forceDistrictEnabled={forceDistrictEnabled}
        />
      </form>
    </div>
  );
};
export default UserPage2;
